/**
 * Core / Mint: Computed.
 * ------------------------------------------------------------------------------
 * - Shared `computed` methods
 * - This is a shared Vue computed object that will be imported across:
 *   - Mint Core, Mint Sections, Mint Components
 * - This allows Pinia to share a state between every different Vue instance
 * @namespace MintComputed
 */
import { mapState } from 'pinia'

import { useCartStore } from '~stores/cart'
import { useFeatureFlagStore } from '~stores/feature-flags'
import { useLocaleStore } from '~stores/locale'
import { useProductStore } from '~stores/product'
import { useScreenStore } from '~stores/screen'
import { useWishlistStore } from '~stores/wishlist'

/**
 * Export computed methods.
 * - These will be imported into mint-[section/components/core].js
 *   to keep things in sync.
 * @return {Object}
 */
export default () => {
  return {
    ...mapState(useCartStore, ['cartData']),
    ...mapState(useFeatureFlagStore, ['featureFlags']),
    ...mapState(useLocaleStore, ['locale']),
    ...mapState(useProductStore, {
      currentVariant: 'currentVariant',
      product: 'productData',
    }),
    ...mapState(useScreenStore, ['screen']),
    ...mapState(useWishlistStore, ['wishlistData']),
  }
}